import * as Popover from "@radix-ui/react-popover";
import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconXClose from "../../../img/icons/x-close.svg";

import styles from "./index.module.scss";

/**
 * Renders form field tooltip
 */
export const FormTooltip = (
    props: Immutable<{
        tooltipText?: string;
        tooltipLink?: string;
        tooltipClass?: string;
        isIconTrigger?: boolean;
    }>,
): React.ReactNode => {
    const titleId = React.useId();

    if (!props.tooltipText) {
        return null;
    }

    const triggerLabel = props.tooltipLink ?? t`Additional information`;

    const tooltipTriggerClasses = classNames(
        styles.trigger,
        props.tooltipClass,
    );

    const triggerWrapperClasses = classNames(styles.triggerWrapper, {
        [styles.triggerWrapperIcon]: props.isIconTrigger,
    });

    return (
        <Popover.Root modal={true}>
            {/*
              Focus ring lives on the wrapper: masked .tooltipIcon buttons
              clip outline/box-shadow on the <button> itself (A360 #377).
            */}
            <span className={triggerWrapperClasses}>
                <Popover.Trigger
                    asChild
                    aria-expanded={undefined}
                    aria-controls={undefined}
                >
                    <button type="button" className={tooltipTriggerClasses}>
                        {triggerLabel}
                    </button>
                </Popover.Trigger>
            </span>
            <Popover.Portal>
                <Popover.Content
                    aria-labelledby={titleId}
                    aria-modal={true}
                    role="dialog"
                    className={styles.container}
                    sideOffset={5}
                    style={{ zIndex: 30000 }}
                >
                    <h2 className="ada-screenreader-only" id={titleId}>
                        {triggerLabel}
                    </h2>
                    <span className={styles.content}>{props.tooltipText}</span>
                    <Popover.Close
                        type="button"
                        className={styles.closeButton}
                        aria-label={t`Close`}
                    >
                        <SVG src={iconXClose} aria-hidden="true" />
                    </Popover.Close>
                    <Popover.Arrow />
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
};
